import * as z from "zod";

export const returnsAnalyticsOverviewBucketSchema = z.enum([
  "day",
  "week",
  "month",
]);
export type ReturnsAnalyticsOverviewBucket = z.infer<
  typeof returnsAnalyticsOverviewBucketSchema
>;

export const getReturnsAnalyticsOverviewInputSchema = z.object({
  startDate: z.string().datetime(),
  endDate: z.string().datetime(),
});
export type GetReturnsAnalyticsOverviewInput = z.infer<
  typeof getReturnsAnalyticsOverviewInputSchema
>;

const returnsAnalyticsOverviewPointSchema = z.object({
  date: z.string(),
  totalReturnsInstalls: z.number().int().min(0),
  totalClosedWon: z.number().int().min(0),
  selfOnboardedClosedWon: z.number().int().min(0),
  averageDealSizeCents: z.number().min(0).nullable(),
  averageSelfServeDealSizeCents: z.number().min(0).nullable(),
});

const returnsAnalyticsOverviewAttributionSchema = z.object({
  exact: z.number().int().min(0),
  inferred: z.number().int().min(0),
  unknown: z.number().int().min(0),
});

export const getReturnsAnalyticsOverviewOutputSchema = z.object({
  bucket: returnsAnalyticsOverviewBucketSchema,
  dataPoints: z.array(returnsAnalyticsOverviewPointSchema),
  summary: z.object({
    totalReturnsInstalls: z.number().int().min(0),
    totalClosedWon: z.number().int().min(0),
    selfOnboardedClosedWon: z.number().int().min(0),
    averageDealSizeCents: z.number().min(0).nullable(),
    averageSelfServeDealSizeCents: z.number().min(0).nullable(),
    averageSelfServePredictedArrCents: z.number().min(0).nullable(),
    attribution: returnsAnalyticsOverviewAttributionSchema,
  }),
});
export type GetReturnsAnalyticsOverviewOutput = z.infer<
  typeof getReturnsAnalyticsOverviewOutputSchema
>;

export const getReturnsAnalyticsOverview = {
  name: "getReturnsAnalyticsOverview" as const,
  input: getReturnsAnalyticsOverviewInputSchema,
  output: getReturnsAnalyticsOverviewOutputSchema,
};
